import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './SplashScene.scss'

export default class SplashScene extends Component {

  render () {
    return (
      <CSSTransitionGroup
        transitionAppear
        transitionAppearTimeout={7000}
        transitionName='bo_splash'
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
      >
        {this.props.visible &&
          <div>
            <div className='bo_splash' key='splash'>
              <div className='bo_splash__content'>
                <div id='bo_poster' className='bo_poster ready-to-display' style={{ backgroundImage: `url(${this.props.background})` }} />
                <div
                  id='bo_splash__logo'
                  className='bo_splash__logo'
                  style={{ backgroundImage: `url(${this.props.logo})` }}
                />
                <div id='bo_splash__title' className='bo_splash__title'>{ this.props.title }</div>
              </div>
            </div>
          </div>
        }
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    title: PropTypes.string,
    logo: PropTypes.string,
    background: PropTypes.string,
    visible: PropTypes.bool,
  }
}



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/splash/SplashScene.js